<template>
  <main style="height: 100%;">
    <v-table
        request-uri="/admin/settings/cities/getList"
        id="cities"
        key="cities"
        ref="citiesTable"
    >
      <template v-slot:header>
        <v-tr>
          <v-th name="name">Название</v-th>
          <v-th name="nameShort">Кратко</v-th>
          <v-th name="nameSlug">URL</v-th>
          <v-th name="nameInfo">Падежи</v-th>
          <v-th name="created_at">Создан</v-th>
        </v-tr>

        <v-tr>
          <v-th name="name" v-slot="{filter}">
            <v-input v-model="filter.value" />
          </v-th>
          <v-th name="nameShort" v-slot="{filter}">
            <v-input v-model="filter.value" />
          </v-th>
          <v-th name="nameSlug" v-slot="{filter}">
            <v-input v-model="filter.value" />
          </v-th>
          <v-th name="nameInfo"/>
          <v-th name="created_at" v-slot="{filter}">
            <date-picker v-model="filter.value"/>
          </v-th>
        </v-tr>
      </template>

      <template v-slot:row="{ item, index }">
        <v-tr @click="openCityEditDialog(item)">
          <v-td name="name"> {{ item.name }}</v-td>
          <v-td name="nameShort"> {{ item.nameInfo.short }}</v-td>
          <v-td name="nameSlug"> {{ item.nameSlug }}</v-td>
          <v-td name="nameInfo"><name-info :city="item"></name-info></v-td>
          <v-td name="created_at" highlight="*">{{ item.created_at | formatDate }}</v-td>
        </v-tr>
      </template>
    </v-table>
    <city-dialog ref="cityDialog" @close="reload()"></city-dialog>
  </main>
</template>

<script>
import DatePicker from "@base/DatePicker";
import NameInfo from "./NameInfo";
import CityDialog from "@dialogs/admin/settings/cities/CityDialog";

export default {
  data() {
    return {}
  },
  props: {},
  components: {
    'date-picker': DatePicker,
    'name-info': NameInfo,
    'city-dialog': CityDialog,
  },
  created() {
  },
  methods: {
    openCityEditDialog: function (item) {
      this.$refs.cityDialog.show(item);
    },

    reload: function () {
      this.$refs.citiesTable.update();
    }
  },
  computed: {
  }
}
</script>
<style>
#cityDialog {
  width: 650px;
}

#specialitiesDialog, #typesDialog, #servicesDialog {
  width: 80%;
}

</style>
